// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","293":"news_page","584":"news_list","681":"language_select","773":"customize"}[chunkId] + "." + {"18":"550db656","293":"c3f306b8","584":"2ff4f0ec","681":"499483c9","773":"09ff085c"}[chunkId] + ".css";
};